import { Link } from "react-router-dom";

export const CtaBand = ({ title = "Ready to order?", text = "Browse the full menu and check out in minutes. Free delivery on orders over $50.", primary = { to: "/shop/", label: "Shop Now" }, secondary = { to: "/deals/", label: "View Deals" } }) => (
  <section className="container-x py-16 sm:py-20" aria-labelledby="cta-title">
    <div className="grain relative overflow-hidden rounded-3xl border border-gold/30 bg-panel px-6 py-12 sm:px-12 sm:py-16">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-jade/10 blur-3xl" aria-hidden />
      <div className="relative flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-2xl">
          <h2 id="cta-title" className="text-3xl font-semibold text-white sm:text-4xl">{title}</h2>
          <p className="mt-3 text-base text-gray-400">{text}</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link to={primary.to} className="btn-gold" data-testid="cta-primary-button">{primary.label}</Link>
          {secondary && <Link to={secondary.to} className="btn-ghost" data-testid="cta-secondary-button">{secondary.label}</Link>}
        </div>
      </div>
    </div>
  </section>
);

export const SectionHead = ({ eyebrow, title, id, action }) => (
  <div className="mb-8 flex items-end justify-between gap-4">
    <div>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 id={id} className="mt-2 text-3xl font-semibold text-white sm:text-4xl">{title}</h2>
    </div>
    {action}
  </div>
);
